import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageSquarePlus, X } from 'lucide-react';
import FeedbackForm from './FeedbackForm';

export default function FeedbackWidget({ getHeaders, primaryColor = '#2563eb' }) {
  const { t } = useTranslation('dashboard');
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-40 flex items-center gap-2 px-4 py-3 rounded-full shadow-lg text-white text-sm font-medium hover:shadow-xl transition-all hover:-translate-y-0.5"
        style={{ backgroundColor: primaryColor }}
        data-testid="feedback-fab"
        aria-label={t('feedback.fab', 'Send Feedback')}
      >
        <MessageSquarePlus className="h-5 w-5" />
        <span className="hidden sm:inline">{t('feedback.fab', 'Send Feedback')}</span>
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" data-testid="feedback-modal">
          <div className="fixed inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <div className="relative bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl shadow-2xl p-5 sm:p-6 animate-in slide-in-from-bottom-4">
            <div className="flex items-start justify-between mb-1">
              <div>
                <h3 className="text-base font-semibold text-gray-900">{t('feedback.title', 'Share your feedback')}</h3>
                <p className="text-xs text-gray-500 mt-0.5">{t('feedback.subtitle', 'Your ideas and issues help us build a better platform.')}</p>
              </div>
              <button onClick={() => setOpen(false)} className="text-gray-400 hover:text-gray-700 -mt-1" data-testid="feedback-modal-close">
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="mt-4">
              <FeedbackForm getHeaders={getHeaders} compact onSubmitted={() => {}} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
